import { render, staticRenderFns } from "./SystemMessageDetailsModal.vue?vue&type=template&id=264a6d80&scoped=true"
import script from "./SystemMessageDetailsModal.vue?vue&type=script&lang=ts"
export * from "./SystemMessageDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./SystemMessageDetailsModal.vue?vue&type=style&index=0&id=264a6d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a6d80",
  null
  
)

export default component.exports